export const createSubmissionsApi = (apiCall: any) => ({
  list: async (page: number = 1, perPage: number = 20) =>
    await apiCall(`/submissions?page=${page}&per_page=${perPage}`, "GET"),
});
